import { Suspense, useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import Cookies from 'universal-cookie'
import { Routes } from './routing/Routes'
import './styles/global.scss'

const cookies = new Cookies()
const VERIFY_COOKIE = 'verifyToken'
const VERIFY_COOKIE_ADMIN = 'verifyTokenAdmin'
export const ONBOARDING_COOKIE = 'onboardingAccessToken'

const App = ({ basename }) => {
  useEffect(() => {
    cookies.remove(VERIFY_COOKIE)
    cookies.remove(VERIFY_COOKIE_ADMIN)
    cookies.remove(ONBOARDING_COOKIE)
  }, [])

  return (
    <Suspense fallback={<div></div>}>
      <BrowserRouter basename={basename}>
        <Routes />
      </BrowserRouter>
    </Suspense>
  )
}

export { App }
